import React, { useCallback, useState } from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useTranslation } from 'react-i18next';
import { Button, useTheme } from '@mui/material';
import { ReactComponent as KeyboardArrowDown } from 'src/assets/icons/keyboard_arrow_down.svg';
import { ReactComponent as MexicanFlag } from 'src/assets/icons/mx_flag.svg';
import EEUUFlag from 'src/assets/images/us_flag.png';
import dayjs from 'src/utils/dayjs';

const I18nMenu = () => {
  const { t, i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const theme = useTheme();

  const handleClick = useCallback(
    event => {
      setAnchorEl(event.currentTarget);
    },
    [setAnchorEl]
  );

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, [setAnchorEl]);

  const changeLanguage = useCallback(
    lng => () => {
      i18n.changeLanguage(lng);
      dayjs.locale(lng);
      localStorage.setItem('lang', lng);
      handleClose();
    },
    [i18n, handleClose]
  );

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <Button
        color="inherit"
        aria-label="lang"
        aria-controls="lang-menu"
        aria-haspopup="true"
        endIcon={<KeyboardArrowDown fill={theme.palette.text.primary} />}
        onClick={handleClick}
      >
        {t('DASHBOARD.LANG_ACRONYM')}
      </Button>
      {i18n.language === 'es' ? (
        <MexicanFlag />
      ) : (
        <img src={EEUUFlag} width={24} height={16} alt="EN Flag" />
      )}

      <Menu
        id="lang-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem
          selected={i18n.language === 'es'}
          onClick={changeLanguage('es')}
        >
          Español
        </MenuItem>
        <MenuItem
          selected={i18n.language === 'en'}
          onClick={changeLanguage('en')}
        >
          English
        </MenuItem>
      </Menu>
    </div>
  );
};

export default I18nMenu;
